@if (hasMainNavigation()) {
  <adcl-main-navigation
    productName="Mareon"
    [productIcon]="productIcon()"
    (menuItemClicked)="itemClicked($event)"
    [menuItems]="menuItems()"
  >
  </adcl-main-navigation>
}
<div class="adcl-container" [class.has-main-navigation]="hasMainNavigation()">
  <div class="adcl-row">
    <router-outlet></router-outlet>
  </div>
</div>

<adcl-user-menu
  [profile]="userMenuProfile"
  [logout]="userMenuLogout"
  [privacy]="userMenuPrivacy"
  [termsOfUse]="userMenuTOS"
  (click)="userMenuSectionClicked($event)"
>
</adcl-user-menu>

<adcl-user-menu headerText="Choose theme" >
  <div adcl-user-menu-item (click)="selectTheme('light')" [selected]="selectedTheme() === 'light'">Light</div>
  <div adcl-user-menu-item (click)="selectTheme('dark')" [selected]="selectedTheme() === 'dark'">Dark</div>
</adcl-user-menu>

<app-mareon-loading-indicator></app-mareon-loading-indicator>
<app-mareon-error-handler></app-mareon-error-handler>
